module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle-default/vehicle-default.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle-default/vehicle-default.component.css
// module chunks = main